import { render } from "./RelatedContents.vue?vue&type=template&id=dd1a513a&scoped=true"
import script from "./RelatedContents.vue?vue&type=script&lang=js"
export * from "./RelatedContents.vue?vue&type=script&lang=js"

import "./RelatedContents.scss?vue&type=style&index=0&id=dd1a513a&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd1a513a"]])

export default __exports__